import { RECORD_FIELDS } from "../../models/recordFields";

/**
 * @typedef {Object} FieldDefinition
 * @property {string} fieldKey - Clave única del campo (por ejemplo "fotoFile").
 * @property {string} label - Etiqueta a mostrar.
 * @property {string[]} [visibleIn] - Vistas en las que se muestra (ej. ["userEdicion"]).
 * @property {string[]} [applicableTypes] - Tipos de objeto a los que se aplica (ej. ["mascota","persona"]).
 * @property {string[]} [options] - Opciones (en caso de select, etc.).
 * @property {string} [inputType] - "text", "select", "checkbox", "file", etc.
 * @property {any} [default] - Valor por default.
 * @property {number} [orderList] - Orden si lo usas en listados, etc.
 */

/**
 * Retorna un arreglo de definiciones de campos que:
 *   1) Tengan "userEdicion" en su lista "visibleIn".
 *   2) Su "applicableTypes" contenga el tipo de objeto (si está definido).
 *
 * @param {Object} objeto - El objeto que estamos editando (debe tener objeto.tipo)
 * @returns {FieldDefinition[]} Lista de campos para la edición del usuario.
 */
export function getFieldsForUserEdicion(objeto) {
  const tipo = objeto?.tipo || ""; 
  // "tipo" podría ser "mascota", "persona", "llavero", etc.

  // 1) Convertir RECORD_FIELDS (un objeto) a array:
  //    { fotoFile: {...}, nombre: {...} } => [{fieldKey:"fotoFile",...}, {fieldKey:"nombre",...}]
  const allFields = Object.entries(RECORD_FIELDS).map(([fieldKey, def]) => {
    return { fieldKey, ...def };
  });

  // 2) Filtrar:
  const filtered = allFields.filter((fieldDef) => {
    // (a) visibleIn -> Debe incluir "userEdicion"
    const isVisible = fieldDef.visibleIn?.includes("userEdicion");

    // (b) applicableTypes -> si está definido, debe incluir el "tipo"
    //     si no existe o está vacío, lo consideramos aplicable a todos
    const isApplicable =
      !fieldDef.applicableTypes ||
      fieldDef.applicableTypes.length === 0 ||
      fieldDef.applicableTypes.includes(tipo);

    return isVisible && isApplicable;
  });

  return filtered;
}